import request from "@/utils/request";
import { jsonHeaders } from "./api-header-conf.js";

export function wxPayAll(payId, openId, data) {
  return request({
    headers: jsonHeaders,
    url: `/pay/publicPay/${payId}/${openId}`,
    method: "GET",
    params: data
  });
}

export function wxPayPart(payId, payNum, openId) {
  return request({
    headers: jsonHeaders,
    url: `/pay/publicPay/${payId}/${payNum}/${openId}`,
    method: "GET"
  });
}
